import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import Item from './components/Item/Item'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import Actions from './components/Actions/Actions'
import { cloneDeep, orderBy } from 'lodash'
import { useDispatch } from 'react-redux'
import { updateSliderItemOrder } from '../actions'
import { useSelector } from 'react-redux'
import styles from './Sliders.module.scss'

function Sliders({}) {

  const sliders = useSelector(state => state.slider.sliders)
  const [selectedSliders, setSelectedSliders] = useState([])
  const [items, setItems] = useState([])
  const [countLoad, setCountLoad] = useState(0)
  const dispatch = useDispatch()

  useEffect(() => {
    let tmp_item = sliders.map(item => ({
      ...item, 
      order_x: isNaN(parseInt(item.order_x)) ? 0 : parseInt(item.order_x)
    }))
    setItems(orderBy(tmp_item, ['order_x'], ['asc']));
  }, [sliders]);


  const onDragEnd = async (result) => {
    const { destination, source, type } = result;

		if(!destination){
			return;
		}

		if(destination.droppableId === source.droppableId && destination.index === source.index){
			return;
		}

    let itemsTmp = cloneDeep(items); 
    const item = itemsTmp[source.index];

    itemsTmp.splice( source.index, 1);
    itemsTmp.splice( destination.index, 0, item);
    dispatch(updateSliderItemOrder(itemsTmp.map((item, index) => ({id: item.id, order_x: index}))))
    setItems(itemsTmp)
  }

  const onSelectedSlide = (v) => {
    setSelectedSliders(v)
  }

  const countImgs = items.length;

  return (
    <div className={classNames('col-md-3', styles.Sliders)}> 
        <Actions
          // loadFileSpiner={this.props.loadFileSpiner} 
          countImgs={countImgs}
          items={items}
          selectedSliders={selectedSliders}
          onSelectedSlide={onSelectedSlide}
        />
        <div className={styles["items"]}>
          <DragDropContext
						onDragEnd={onDragEnd}
					>
            <Droppable droppableId="all-items" direction="vertical" type="items">
							{(provided) => (<div
							 ref={provided.innerRef}
							 {...provided.droppableProps}
							>
                {items.map((item, index) => <Item
                  // setLoadImg={this.setLoadImg} 
                  item={item} 
                  index={index} 
                  key={'slide-item' + item.id}
                  selectedSliders={selectedSliders}
                  onSelectedSlide={onSelectedSlide}
                />)}
								{provided.placeholder}
							</div>
							)}
						</Droppable>
          </DragDropContext>

        </div>
    </div>
  )
}

export default Sliders